import {AuthService} from "./AuthService";

export class OnboardingService {
    url = `campaigns/`;

    // Live onboarding status (state pointer + per-step computed summary).
    getStatus(campaignId) {
        return AuthService.apiGet(this.url + campaignId + "/onboarding/").then(res => res.data.data);
    }

    // Persist the wizard pointer. Pass any subset of {state, completed_steps, dismissed}.
    advance(campaignId, payload) {
        return AuthService.apiPut(this.url + campaignId + "/onboarding/advance/", {onboarding: payload}).then(res => res.data.data);
    }

    setState(campaignId, state) {
        return this.advance(campaignId, {state: state});
    }

    // Re-enter the flow at the first step (e.g. for a new batch of products).
    restart(campaignId) {
        return AuthService.apiPut(this.url + campaignId + "/onboarding/restart/", {}).then(res => res.data.data);
    }

    dismiss(campaignId) {
        return this.advance(campaignId, {dismissed: true});
    }
}
